import { Owner } from "./shop/owner";

export class Settings {
	cdn_url: string;
	base_url: string;
	offer_footer_text: string;
	default_classification: number;
    default_pricelist: number;
    languages: string[];
    tax_rates: TaxRate[];
    shop_owner: Owner;
}

export class TaxRate {
    class_id: number;
    rate: number;
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/models/settings.ts